module.exports = __webpack_public_path__ + "img/amx-12.6bd3db12.jpg";